module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Also by Jim Harrison")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Wolf"), _c('br'), _vm._v("A Good Day to Die")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Farmer"), _c('br'), _vm._v("Legends of the Fall"), _c('br'), _vm._v("Warlock"), _c('br'), _vm._v("Sundog"), _c('br'), _vm._v("Dalva")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Woman Lit by Fireflies"), _c('br'), _vm._v("Julip"), _c('br'), _vm._v("The Road Home"), _c('br'), _vm._v("The Beast God Forgot to Invent"), _c('br'), _vm._v("True North"), _c('br'), _vm._v("The Summer He Didn’t Die")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHILDREN’S LITERATURE")]), _c('br'), _c('em', [_vm._v("The Boy Who Ran to the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETRY")]), _c('br'), _c('em', [_vm._v("Plain Song"), _c('br'), _vm._v("Locations"), _c('br'), _vm._v("Outlyer and Ghazals"), _c('br'), _vm._v("Letters to Yesenin and Returning to Earth"), _c('br'), _vm._v("Selected & New Poems"), _c('br'), _vm._v("The Theory and Practice of Rivers & Other Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("After Ikky"), _c('span', {
    staticClass: "en363"
  }, [_vm._v("ū")]), _vm._v(" & Other Poems"), _c('br'), _vm._v("The Shape of the Journey: New and Collected Poems"), _c('br'), _vm._v("Braided Creek")]), _vm._v(" (with Ted Kooser)"), _c('br'), _c('em', [_vm._v("Saving Daylight")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ESSAYS")]), _c('br'), _c('em', [_vm._v("Just Before Dark"), _c('br'), _vm._v("The Raw and the Cooked")])]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MEMOIR")]), _c('br'), _c('em', [_vm._v("Off to the Side")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2be58f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 75
// module chunks = 0